import React, { useContext } from 'react';
import { BreakpointContext, XLARGE } from '@core-ui/breakpoint-provider';
// @ts-ignore
import { RailContext } from '@cat/rail';
import { Accordion } from '@core-ui/accordion';
// @ts-ignore
import AccordionItem from './components/AccordionItem';
import { Option } from '../types';

type FacetBarProps = {
  appliedFacets: { [parameter: string]: Option[] };
  defaultExpanded?: string[];
  facets: [];
  isSwitchContractEnabled?: boolean;
  singlePanelExpanded?: boolean;
};

const FacetBar = ({
  appliedFacets,
  defaultExpanded = [],
  facets,
  isSwitchContractEnabled,
  singlePanelExpanded = true,
}: FacetBarProps) => {
  const { smallerThan } = useContext(BreakpointContext);
  const { scrollableRef } = useContext(RailContext);
  const isMobile = smallerThan(XLARGE);

  return (
    <Accordion
      defaultExpanded={defaultExpanded}
      singlePanelExpanded={singlePanelExpanded}
      sticky
    >
      {facets.map((facet, i) => (
        <AccordionItem
          /* eslint-disable-next-line react/no-array-index-key */
          key={i}
          appliedFacets={appliedFacets}
          facet={facet}
          isMobile={isMobile}
          isSwitchContractEnabled={isSwitchContractEnabled}
          scrollableElement={scrollableRef as HTMLElement}
        />
      ))}
    </Accordion>
  );
};

export default FacetBar;
